import SmoothScroll from 'smooth-scroll'
import {asyncForEach} from '../utils/'
const MINUS_POSITION_OF_CONTAINER = 100
const scroll = new SmoothScroll()

class Filters {
	constructor (itemsContainer) {
		this.value = ''
		this.observersCollection = []
		this.itemsContainer = itemsContainer
	}

	get () {
		return this.value
	}

	async set (value, notify = true) {
		this.value = value
		if (notify) {
			await this.notify()
			this.scrollDown()
		}
	}

	addObserver (cb) {
		this.observersCollection.push(cb)
	}

	async notify () {
		await asyncForEach(this.observersCollection, async observer => {
			await observer(true)
		})
	}

	scrollDown () {
		if (window.innerWidth >= 576) return false
		const elementTop = this.itemsContainer.getBoundingClientRect().top
		const scrollTo = elementTop + window.scrollY - MINUS_POSITION_OF_CONTAINER
		scroll.animateScroll(scrollTo, null, {
			speed: 1000
		})
	}
}

export default Filters



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/filters/Filters.js